export const formatNominalTime = (value) => {
  let date = new Date(null);
  date.setSeconds(value); // specify value for SECONDS here
  return date.toISOString().substr(11, 8);
};
